import { Link } from "react-router-dom";

const ProductsBtn = ({ id }: { id: number }) => {
  return (
    <div className="sticky top-[82px] md:top-20 xl:top-32 left-0  w-full h-fit bg-light pt-3.5 z-10">
      <div className="relative w-full h-fit max-w-screen-md mx-auto text-center grid grid-cols-2 px-2 xl:gap-14">
        <Link
          to={"/products/features"}
          type="button"
          className={
            id === 0
              ? "relative lg:px-8 w-full h-full border-b-8 border-font"
              : "pb-3"
          }
        >
          <p>제품 특장점</p>
        </Link>
        <Link
          to={"/products/line-up"}
          type="button"
          className={
            id === 1
              ? "relative lg:px-8 w-full h-full border-b-8 border-font"
              : "pb-3"
          }
        >
          <p>제품별 Line-up</p>
        </Link>
      </div>
    </div>
  );
};

export default ProductsBtn;
